import { images } from '../constants';

const products = [ 
    {
        id: 1,
        image: images.product1Gallery1, 
        name: 'Lawn Mower',
        price: 450,
        disprice: 430,
        content: "Effortlessly maintain your lawn with our high-performance Lawn Mower. Designed for precision cutting and easy maneuverability, this tool ensures a pristine lawn every time. Featuring adjustable cutting heights, you can customize the mow to suit your grass type and desired finish. The ergonomic handle offers a comfortable grip, reducing strain during long mowing sessions. Its durable, weather-resistant construction ensures longevity, even with frequent use.",
        description: 'Our advanced Lawn Mower is built to handle both small and large lawns with efficiency. Featuring a powerful motor, adjustable cutting heights, and an ergonomic handle, it guarantees a smooth mowing experience. The durable steel blades and grass collection bag make maintenance hassle-free. Whether for home gardens or commercial landscapes, this mower delivers exceptional performance.',
        category: ['Garden Tools', 'Landscaping Materials'],
        tags: ['Gardening', 'Landscaping', 'Maintenance'],
        gallery: {
            image1: images.product1Gallery1, 
            image2: images.product1Gallery2, 
            image3: images.product1Gallery3, 
            image4: images.product1Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Power Source', content: 'Electric / Gasoline' },
            { id: 2, title: 'Cutting Width', content: '20 inches' },
            { id: 3, title: 'Height Adjustment', content: '1.5 - 4 inches' },
            { id: 4, title: 'Weight', content: '12Kg' },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: 'David Green',
                date: 'August 5, 2024',
                rating: 5,
                content: 'This Lawn Mower is a game changer! Super easy to use, and my lawn has never looked better.',
            },
            {
                id: 2,
                image: images.product2Review2,
                name: 'Sarah Thompson',
                date: 'August 10, 2024',
                rating: 4.8,
                content: 'Very efficient and lightweight. I love the adjustable cutting heights and smooth operation!',
            },
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1, 
        name: 'Lavender Plant',
        price: 25,
        disprice: 20,
        content: 'Enhance your garden with the soothing fragrance and beauty of our premium Lavender Plant. Ideal for gardens, patios, and indoor spaces. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Lavender is a versatile and fragrant herb known for its calming aroma and stunning purple blooms. Perfect for gardens, balconies, or even indoor pots, this low-maintenance plant thrives in full sunlight and well-drained soil. Beyond its beauty, lavender is widely used in aromatherapy, herbal remedies, and as a natural insect repellent. Add a touch of tranquility to your outdoor space with this delightful plant.',
        category: ['Plants & Flowers', 'Fruit & Trees'],
        tags: ['Plants', 'Flowers', 'Outdoor'],
        gallery: {
            image1: images.product2Gallery1, 
            image2: images.product2Gallery2, 
            image3: images.product2Gallery3, 
            image4: images.product2Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Plant Type', content: 'Perennial Herb' },
            { id: 2, title: 'Sunlight', content: 'Full Sun' },
            { id: 3, title: 'Watering', content: 'Once or twice a week' },
            { id: 4, title: 'Soil Type', content: 'Well-drained, sandy soil' },
            { id: 5, title: 'Height', content: '12-36 inches' },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: 'Emma Davis',
                date: 'July 15, 2024',
                rating: 5,
                content: 'Absolutely love my Lavender Plant! It adds a refreshing scent to my garden and requires minimal care.',
            },
            {
                id: 2,
                image: images.product3Review2,
                name: 'John Carter',
                date: 'July 20, 2024',
                rating: 4.9,
                content: 'Great quality! The plant arrived healthy and is growing beautifully in my backyard.',
            },
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1, 
        name: 'Garden Shovel',
        price: 45,
        disprice: 40,
        content: 'A durable and ergonomic garden shovel, perfect for digging, planting, and landscaping tasks. Built for comfort and efficiency. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Our premium Garden Shovel is designed for both casual gardeners and professional landscapers. Featuring a rust-resistant steel blade and a sturdy ergonomic handle, this shovel makes digging, transplanting, and soil aeration effortless. Its lightweight yet durable construction ensures long-lasting use, while the non-slip grip enhances comfort and control. Ideal for flower beds, vegetable gardens, and landscaping projects.',
        category: ['Garden Tools', 'Garden Accessories'],
        tags: ['Tools', 'Gardening', 'Maintenance'],
        gallery: {
            image1: images.product3Gallery1, 
            image2: images.product3Gallery2, 
            image3: images.product3Gallery3, 
            image4: images.product3Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'High-Carbon Steel & Wood Handle' },
            { id: 2, title: 'Blade Width', content: '8 inches' },
            { id: 3, title: 'Handle Length', content: '36 inches' },
            { id: 4, title: 'Weight', content: '2.5 lbs' },
            { id: 5, title: 'Rust Resistant', content: 'Yes' },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: 'Alice Green',
                date: 'August 5, 2024',
                rating: 5,
                content: 'A must-have tool for any gardener! It’s sturdy, lightweight, and comfortable to use.',
            },
            {
                id: 2,
                image: images.product4Review1,
                name: 'David Brown',
                date: 'August 7, 2024',
                rating: 4.8,
                content: 'High-quality shovel! The grip is comfortable, and the blade cuts through the soil with ease.',
            },
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1, 
        name: 'Brick Pavers',
        price: 2.50, // Price per piece
        disprice: 2.25, // Discounted price per piece
        content: 'Durable and stylish brick pavers, perfect for patios, walkways, and garden landscaping projects. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Enhance your outdoor spaces with our high-quality Brick Pavers. These weather-resistant bricks offer excellent durability and aesthetic appeal, making them ideal for pathways, patios, and garden borders. Crafted from premium clay, they provide a rustic charm while ensuring long-lasting performance. Available in multiple colors and textures to suit your landscaping needs.',
        category: ['Landscaping Materials', 'Garden Accessories'],
        tags: ['Landscaping', 'Materials', 'Outdoor'],
        gallery: {
            image1: images.product4Gallery1, 
            image2: images.product4Gallery2, 
            image3: images.product4Gallery3, 
            image4: images.product4Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Premium Clay' },
            { id: 2, title: 'Size', content: '8 x 4 x 2 inches' },
            { id: 3, title: 'Weight', content: '5 lbs per brick' },
            { id: 4, title: 'Finish', content: 'Textured / Smooth' },
            { id: 5, title: 'Weather Resistant', content: 'Yes' },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: 'Michael Adams',
                date: 'August 10, 2024',
                rating: 5,
                content: 'Great quality pavers! They added a beautiful touch to my garden walkway.',
            },
            {
                id: 2,
                image: images.product4Review1,
                name: 'Sophia Carter',
                date: 'August 12, 2024',
                rating: 4.9,
                content: 'Solid and durable. Easy to install and looks fantastic in my backyard.',
            },
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1, 
        name: 'Wheelbarrow',
        price: 85.00,
        disprice: 79.99,
        content: 'Heavy-duty wheelbarrow designed for effortless transport of soil, mulch, and garden tools. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Make gardening tasks easier with our durable and easy-to-maneuver wheelbarrow. Featuring a sturdy steel frame, a deep tray for maximum load capacity, and a comfortable grip handle, this wheelbarrow is perfect for transporting soil, plants, tools, and construction materials. The rust-resistant coating ensures longevity, while the pneumatic tire provides smooth movement across different terrains.',
        category: ['Garden Tools', 'Garden Accessories'],
        tags: ['Tools', 'Gardening', 'Landscaping'],
        gallery: {
            image1: images.product5Gallery1, 
            image2: images.product5Gallery2, 
            image3: images.product5Gallery3, 
            image4: images.product5Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Steel Frame & Poly Tray' },
            { id: 2, title: 'Capacity', content: '6 Cubic Feet' },
            { id: 3, title: 'Wheel Type', content: 'Pneumatic Tire' },
            { id: 4, title: 'Weight', content: '30 lbs' },
            { id: 5, title: 'Rust-Resistant', content: 'Yes' },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: 'Daniel Thompson',
                date: 'August 15, 2024',
                rating: 5,
                content: 'Excellent build quality! Sturdy and easy to handle, even with heavy loads.',
            },
            {
                id: 2,
                image: images.product5Review1,
                name: 'Emily Johnson',
                date: 'August 18, 2024',
                rating: 4.8,
                content: 'Perfect for my garden work! The tire moves smoothly over rough terrain.',
            },
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1, 
        name: 'Wind Chimes',
        price: 45.00,
        disprice: 39.99,
        content: 'Beautifully crafted wind chimes that add a soothing melody to your garden. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Enhance your outdoor space with these elegant wind chimes, designed to create a peaceful and harmonious ambiance. Made from high-quality aluminum tubes and a durable wooden top, these chimes produce deep, relaxing tones that resonate with the wind. Perfect for hanging in your garden, patio, or balcony, they serve as both a decorative piece and a source of tranquility. Weather-resistant and built to last, these wind chimes will bring years of enjoyment.',
        category: ['Garden Accessories', 'Plants & Flowers'],
        tags: ['Decor', 'Outdoor', 'Flowers'],
        gallery: {
            image1: images.product6Gallery1, 
            image2: images.product6Gallery2, 
            image3: images.product6Gallery3, 
            image4: images.product6Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Aluminum Tubes & Wooden Top' },
            { id: 2, title: 'Length', content: '32 inches' },
            { id: 3, title: 'Weather-Resistant', content: 'Yes' },
            { id: 4, title: 'Sound Type', content: 'Deep & Melodic' },
            { id: 5, title: 'Hanging Type', content: 'Hook & Cord' },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: 'Sophia Carter',
                date: 'August 10, 2024',
                rating: 5,
                content: 'Absolutely love the soothing sounds! The quality is amazing and it looks beautiful in my garden.',
            },
            {
                id: 2,
                image: images.product6Review1,
                name: 'James Anderson',
                date: 'August 12, 2024',
                rating: 4.9,
                content: 'These wind chimes have such a relaxing tone. The build quality is excellent!',
            },
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1, 
        name: 'Rose Bush',
        price: 25.00,
        disprice: 19.99,
        content: 'A stunning rose bush that adds vibrant color and fragrance to any garden. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Bring timeless beauty to your garden with this lush and fragrant rose bush. Featuring full, vibrant blooms in rich hues, this plant is perfect for creating a romantic and elegant outdoor space. The rose bush thrives in well-drained soil with plenty of sunlight, producing flowers from spring to fall. Whether used as a garden border, centerpiece, or potted plant, it is a must-have for any gardening enthusiast. Low-maintenance yet highly rewarding, this rose bush will bring joy season after season.',
        category: ['Plants & Flowers', 'Landscaping Materials'],
        tags: ['Plants', 'Flowers', 'Gardening'],
        gallery: {
            image1: images.product7Gallery1, 
            image2: images.product7Gallery2, 
            image3: images.product7Gallery3, 
            image4: images.product7Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Plant Type', content: 'Perennial Flowering Shrub' },
            { id: 2, title: 'Sunlight Needs', content: 'Full Sun' },
            { id: 3, title: 'Watering', content: 'Regular, Keep Soil Moist' },
            { id: 4, title: 'Bloom Season', content: 'Spring to Fall' },
            { id: 5, title: 'Soil Type', content: 'Well-Drained, Nutrient-Rich' },
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: 'Emma Thompson',
                date: 'August 15, 2024',
                rating: 5,
                content: 'Absolutely stunning! The roses are so vibrant and bloom beautifully throughout the season.',
            },
            {
                id: 2,
                image: images.product7Review1,
                name: 'Michael Harris',
                date: 'August 18, 2024',
                rating: 4.8,
                content: 'This rose bush is a garden showstopper! The fragrance is amazing, and it’s easy to maintain.',
            },
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1, 
        name: 'Fruit Trees',
        price: 45.00,
        disprice: 39.99,
        content: 'Grow your own fresh, organic fruits with these lush and healthy fruit trees. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Enhance your garden with these vibrant and productive fruit trees. Perfect for home orchards, backyards, or large planters, these trees offer delicious, homegrown fruits while adding beauty to your outdoor space. Our selection includes apple, orange, peach, and lemon trees, all carefully nurtured for healthy growth. With proper care, these trees will provide fresh fruit for years, bringing nature’s sweetness to your home. Thriving best in well-drained soil with plenty of sunlight, these trees make an excellent addition to any garden.',
        category: ['Fruit & Trees', 'Plants & Flowers'],
        tags: ['Trees', 'Plants', 'Outdoor'],
        gallery: {
            image1: images.product8Gallery1, 
            image2: images.product8Gallery2, 
            image3: images.product8Gallery3, 
            image4: images.product8Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Tree Type', content: 'Deciduous & Evergreen' },
            { id: 2, title: 'Sunlight Needs', content: 'Full Sun' },
            { id: 3, title: 'Watering', content: 'Moderate, Keep Soil Moist' },
            { id: 4, title: 'Maturity Time', content: '2-5 Years for Fruit' },
            { id: 5, title: 'Soil Type', content: 'Well-Drained, Fertile Soil' },
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: 'Jessica Parker',
                date: 'August 20, 2024',
                rating: 5,
                content: 'Absolutely love these trees! I planted an apple tree last year, and it’s already thriving!',
            },
            {
                id: 2,
                image: images.product8Review1,
                name: 'Daniel Cooper',
                date: 'August 22, 2024',
                rating: 4.9,
                content: 'Great quality trees. They arrived healthy and are growing beautifully in my backyard.',
            },
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1, 
        name: 'Deck Tile',
        price: 12.99,
        disprice: 10.99,
        content: 'Upgrade your outdoor space with durable and stylish deck tiles for patios and gardens. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt magna at risus interdum, eget tincidunt lorem fermentum. Integer nec felis ut magna tempus vehicula. Fusce vitae lorem neque. Aenean ut augue arcu. Ut euismod tortor sit amet velit vehicula, ac viverra ipsum cursus. Maecenas a nunc id libero tempor egestas non a justo.',
        description: 'Transform your patio, balcony, or garden pathway with high-quality deck tiles. These interlocking tiles provide a sleek and natural wood or stone-like finish, making them a perfect choice for modern outdoor spaces. Made from weather-resistant materials, they are designed to withstand sun, rain, and foot traffic. The easy snap-together design ensures quick installation without the need for tools or adhesives. Ideal for both residential and commercial outdoor settings, these deck tiles add a touch of elegance and functionality to any landscape.',
        category: ['Landscaping Materials', 'Garden Accessories'],
        tags: ['Materials', 'Landscaping', 'Outdoor'],
        gallery: {
            image1: images.product9Gallery1, 
            image2: images.product9Gallery2, 
            image3: images.product9Gallery3, 
            image4: images.product9Gallery4, 
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Wood, Composite, or Stone' },
            { id: 2, title: 'Tile Size', content: '12x12 inches per piece' },
            { id: 3, title: 'Installation', content: 'Snap-Together, No Tools Required' },
            { id: 4, title: 'Weather Resistance', content: 'UV, Water, and Mold Resistant' },
            { id: 5, title: 'Application', content: 'Patios, Balconies, Walkways' },
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: 'Sophia Anderson',
                date: 'August 22, 2024',
                rating: 5,
                content: 'These deck tiles completely transformed my patio! Easy to install and look fantastic.',
            },
        ]
    }
];

export default products;